import React, { useState } from 'react';

import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import SiteEnergyPanel from './SiteEnergyPanel';

const SiteTabContainer = ({
    formik,
    ...props
}) => {
    const [selected, setSelected] = useState(0);
    const handleSelect = (e) => {
        setSelected(e.selected);
    };

    return (
        <React.Fragment>
            <style>
                {
                    `.k-tabstrip-items-wrapper .k-item.k-active::after {
                        border-color: black;
                        font-weight: 500;
                    }
                    .k-tabstrip-items {
                        text-transform: none;
                        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
                        font-weight: 400;
                    }
                    `
                }
            </style>
            <TabStrip selected={selected} onSelect={handleSelect}>
                <TabStripTab title="Energy">
                    <SiteEnergyPanel
                        formik={formik}
                    />
                </TabStripTab>
            </TabStrip>
        </React.Fragment>
    );
};

export default SiteTabContainer;

